import { useState, useEffect } from "react";
import { Grid, Link } from '@mui/material';
import Icon from '../Shared/Icon';
import FormTextField from '../Form/FormTextField';

const Title = props => {
    const [title, setTitle] = useState(props.value)

    useEffect(() => {
        setTitle(props.label)
    }, [props])

    const handleTitleChange = e => {
        setTitle(e.target.value)
        props.handler(e)
    }

    return (
        <Grid item xs>
            <Grid container className={props.row ? "TitleRow" : "Title"}>

                {/* icons */}

                <Grid item>
                    <Grid container>

                        {props.systems && props.systems.map((system, key) => (
                            <Icon key={key} system={system} />
                        ))}
                        {props.icons && props.icons.map((icon, key) => (
                            <Icon key={key} icon={icon} />
                        ))}
                    </Grid>
                </Grid>

                {/* text */}
                {!props.iconOnly &&
                    <Grid item xs>
                        {
                            props.disabled ?
                                <div>{title}</div>
                                :
                                (props.href || props.onClick) ?
                                    <Link href={props.href} onClick={() => props.onClick()} underline="hover" target="_blank">
                                        {title}
                                    </Link>
                                    :
                                    <FormTextField
                                        value={title}
                                        name="Name"
                                        placeholder="Name"
                                        handler={handleTitleChange}
                                        disabled={props.disabled}
                                        disableUnderline
                                    />
                        }
                    </Grid>
                }
            </Grid>
        </Grid>

    )
}
export default Title;